module.exports = __webpack_public_path__ + "static/media/logo161.f66c1369.png";